<template>
  <div class="list-box" id="listBox" ref="listBox">
    <div class="bread-crumb" id="jude-nav-content">
      <div id="nav-content-fixed">
        <a class="link" href="/dynamic.html">小迈动态</a>
        <span class="arrow"></span>
        <span class="plateName">{{ categoryName }}</span>
      </div>
    </div>

    <div class="content weakFadeInUp" id="content">
      <h2>
        {{ categoryName }}
      </h2>

      <div class="content-list" v-loading="listLoading">
        <article-box
          v-for="(item, index) in articleList"
          :key="item.id"
          class="article-box"
          @click.native="handleShowDetail(categoryId, item.id, index)"
          :articleData="item"
        />
      </div>

      <img
        class="cube-div big cube_1 aniamtionCode"
        ref="cube_1"
        :src="'//img.ibestfanli.com/officialwebsite/img_block.png'"
      />

      <img
        class="cube-div big cube_2 aniamtionCode"
        ref="cube_2"
        src="//img.ibestfanli.com/officialwebsite/img_block.png"
      />

      <img
        class="cube-div big cube_3 aniamtionCode"
        ref="cube_3"
        src="//img.ibestfanli.com/officialwebsite/img_block.png"
      />
    </div>

    <transition name="fade">
      <TopBtn v-show="showTopBtn"></TopBtn>
    </transition>
  </div>
</template>

<script>
import ArticleBox from "../../../components/ArticleBox/pc/index";
import TopBtn from "../../../components/topBtn/index";
import Config from "utils/Config";
import CommonMethod from "utils/CommonMethod";
import { getArticleListByDetail } from "@/api/dynamic.js";
import { DYNAMICIN_FORMATION, DYNAMIC_ACTIVITY } from "@/data/dynamicData.js";
export default {
  name: "dynamicPcList",
  components: {
    ArticleBox,
    TopBtn,
  },
  props: {},
  data() {
    return {
      categoryId: "", // 当前文章分类ID
      categoryName: "", // 当前文章分类名

      articleList: [],
      initArticleNum: 6, // 初始化时的文章数
      articleNum: 6, // 每次滚动加载新增文章数
      listLoading: false,
      finishedDataLoad: false,
      commonMethod: null,
      showTopBtn: 0,
      srollFlag: false,
    };
  },
  created() {
    const params = window.location.search.split("=")[1];
    this.categoryId = params;
    switch (Number(params)) {
      case DYNAMICIN_FORMATION:
        this.categoryName = "企业资讯";
        break;
      case DYNAMIC_ACTIVITY:
        this.categoryName = "文化活动";
        break;
      default:
        break;
    }

    this.getCategoryList(this.categoryId, this.initArticleNum);

    this.commonMethod = new CommonMethod({
      context: this,
      judgeNavToFixedEleName: "#jude-nav-content",
    });
  },
  mounted() {
    this.commonMethod.init();
    window.addEventListener("scroll", this.scrollHandle, true);
  },
  methods: {
    // 分Id取文章列表
    async getCategoryList(categoryId, pageSize) {
      try {
        this.listLoading = true;

        const paramMap = {
          categoryId: categoryId,
          pageSize: pageSize,
        };

        const res = await getArticleListByDetail(paramMap);
        if (!res.data) return;

        if (this.articleList.length === res.data.page.list.length) {
          console.log("======数据加载完毕======");
          this.finishedDataLoad = true;
        }
        this.articleList = res.data.page.list;
      } catch (error) {
        console.error(error);
      } finally {
        this.listLoading = false;
      }
    },
    handleShowDetail(categoryId, articleId, index) {
      window.location.href = `${Config.domain}/dynamicDetail.html?categoryId=${categoryId}&id=${articleId}&index=${index}`;
    },
    scrollHandle() {
      const flag = this.judeScroll(); // 根据scroll距离动态新增文章

      if (this.srollFlag !== flag) {
        this.srollFlag = flag;
      } else {
        return;
      }

      if (this.srollFlag && !this.finishedDataLoad) {
        console.log("===== 触发接口======");
        const curNum = this.initArticleNum + this.articleNum;

        this.initArticleNum = curNum;
        this.getCategoryList(this.categoryId, curNum);
      }

      // 方块动画
      this.commonMethod.cubeAnimation(
        "cube_1",
        500,
        "once11",
        "cubeMoveDown",
        "cubeMoveDown2"
      );
      this.commonMethod.cubeAnimation(
        "cube_2",
        300,
        "once22",
        "cubeMoveDown13",
        "cubeMoveDown14"
      );
      this.commonMethod.cubeAnimation(
        "cube_3",
        600,
        "once33",
        "cubeMoveDown13",
        "cubeMoveDown14"
      );

      this.showTopBtnEvt();
    },
    judeScroll() {
      let flag = false;
      // 兼容浏览器
      var clientHeight =
        document.documentElement.scrollTop === 0
          ? document.body.clientHeight
          : document.documentElement.clientHeight;
      var scrollTop =
        document.documentElement.scrollTop === 0
          ? document.body.scrollTop
          : document.documentElement.scrollTop;
      var scrollHeight =
        document.documentElement.scrollTop === 0
          ? document.body.scrollHeight
          : document.documentElement.scrollHeight;

      if (scrollTop != 0 && clientHeight + scrollTop + 300 >= scrollHeight) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    showTopBtnEvt() {
      const { top, height } = document
        .querySelector(".bread-crumb")
        .getBoundingClientRect();

      if (Math.abs(top) >= height / 2) {
        this.showTopBtn = 1;
      } else {
        this.showTopBtn = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 方法
.h2Pc {
  margin: 0;
  font-size: 36px;
  text-align: center;
  padding-top: 80px;
  font-family: PingFangSC-Semibold, PingFang SC;
}

/* -------- 样式 ----- */
h2 {
  .h2Pc;
}

.list-box {
  width: 100%;
  padding-bottom: 80px;
  font-family: PingFangSC-Regular, PingFang SC;
  position: relative;
  overflow: hidden;

  .bread-crumb {
    height: 72px;
    line-height: 72px;
    background: #f2f2f2;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;

    #nav-content-fixed {
      width: 1200px;
      margin: 0 auto;
      font-size: 16px;
      color: #222222;
      display: flex;
      align-items: center;

      .link {
        color: #222222;
        &:hover {
          color: #3292ff;
        }
      }
      .arrow {
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url("~@/assets/img/pc/dynamic/article/icon_arrow_right@2x.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        margin: 0 8px;
      }
    }
  }

  .content {
    position: relative;
    width: 1200px;
    margin: 0 auto;

    .content-list {
      position: relative;
      height: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 60px 24px;
      margin-top: 60px;

      .article-box {
        width: 384px;
        height: 508px;
      }
    }

    .cube_1 {
      width: 450px;
      height: 450px;
      top: 80px;
      right: -570px;
      transform: rotate(-90deg);
    }

    .cube_2 {
      width: 900px;
      height: 900px;
      top: 300px;
      left: -900px;
      transform: translateY(0) rotate(60deg);
    }

    .cube_3 {
      width: 300px;
      height: 300px;
      bottom: -280px;
      right: -240px;
      transform: translateY(0) rotate(60deg);
    }
  }
}

//控制模块上移的动画
.weakFadeInUp {
  animation-name: weakFadeInUp;
  animation-duration: 1s;
}

@keyframes weakFadeInUp {
  0% {
    transform: translateY(50px);
  }

  100% {
    transform: translateY(0px);
  }
}

@media screen and (min-width: 1200px) {
  .list-box .content-list {
    &::after {
      content: "";
      position: absolute;
      left: -100px;
      top: 180px;
      .imgInfoP(217px, 107px, "dynamic/article/img_matrix@2x.png");
      z-index: -1;
    }
  }
}

// 大屏ipad
@media screen and (min-width: 900px) and (max-width: 1200px) {
  .safeArea {
    width: 844px;
  }

  .list-box {
    .bread-crumb {
      #nav-content-fixed {
        width: 844px;
        margin: 0 auto;
      }
    }

    .content {
      .safeArea !important;
      margin: 0 auto;

      .content-list {
        position: relative;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 60px 24px;
        margin-top: 60px;

        .article-box {
          width: 420px;
          height: 540px;
        }
        .article-box:hover {
          transform: inherit;
        }
      }

      .cube_3 {
        left: -360px;
      }
    }
  }
}

// ipad
@media screen and (min-width: 700px) /* (min-width: 768px) */ and (max-width: 900px) {
  .safeArea {
    width: 648px;
  }

  .list-box {
    .bread-crumb {
      #nav-content-fixed {
        width: 644px;
        margin: 0 auto;
      }
    }

    .content {
      .safeArea !important;
      margin: 0 auto;

      .content-list {
        position: relative;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 60px 24px;
        margin-top: 60px;

        .article-box {
          width: 312px;
          height: 500px;
        }
        .article-box:hover {
          transform: inherit;
        }
      }

      .cube_3 {
        left: -360px;
      }
    }
  }
}
</style>